import { Outlet } from 'react-router-dom';
import { Layout } from '../Layout';

export const AppLayout = () => {
    return (
        <Layout>
            <Outlet />
        </Layout>
    );
};
